import React, { useMemo } from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import withRouter from "components/Common/withRouter"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import { t } from "i18next"
import TableContainer from "components/Common/TableContainer"
import { CurrentTapType, Offer } from "./Offers"
import { useTranslation } from "react-i18next"

interface OffersTableProps {
  offers: Offer[]
  isAllChecked: boolean
  checkedOffers: Offer[]
  toggleAllOffers: () => void
  togglecheckedOfferHandler: (offer: Offer) => void
  toggleActiveOffer: (offer: Offer) => void
  editOfferHandler: (offer: Offer) => void
  viewDetailsHandler: (offer: Offer) => void
  deleteOfferHandler: (offer: Offer) => void
  location?: any
}

const OffersTable: React.FC<OffersTableProps> = ({
  offers,
  isAllChecked,
  checkedOffers,
  toggleAllOffers,
  togglecheckedOfferHandler,
  toggleActiveOffer,
  editOfferHandler,
  viewDetailsHandler,
  deleteOfferHandler,
  location,
}) => {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <input
            type="checkbox"
            className="form-check-input"
            onClick={toggleAllOffers}
            checked={isAllChecked}
            onChange={() => {}}
          />
        ),
        accessor: "id",
        Cell: (cellProps: { row: { original: Offer } }) => {
          return (
            <input
              onClick={() => {
                togglecheckedOfferHandler(cellProps.row.original)
              }}
              checked={Boolean(
                checkedOffers?.find(c => c.id === cellProps.row.original.id)
              )}
              onChange={() => {}}
              type="checkbox"
              className="form-check-input"
            />
          )
        },
      },
      {
        Header: t("offers_offerTitle"),
        accessor: "title",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          return (
            <div className="d-flex flex-column align-items-start">
              <p className="mb-0">{cellProps.row.original.title}</p>
              <p className="mb-0">{cellProps.row.original.id}</p>
            </div>
          )
        },
      },
      {
        Header: t("offers_offerType"),
        accessor: "category",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          return <>{cellProps.row.original.category}</>
        },
      },
      {
        Header: t("offers_validityPeriod"),
        accessor: "startDate",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          return (
            <>
              {cellProps.row.original.startDate} To{" "}
              {cellProps.row.original.endDate}
            </>
          )
        },
      },
      {
        Header: t("offers_usageTime"),
        accessor: "periodTime",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          return <>{cellProps.row.original.periodTime}</>
        },
      },
      {
        Header: t("offers_offerPrice"),
        accessor: "price",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          return <>{cellProps.row.original.price}</>
        },
      },
      {
        Header: t("common_status"),
        accessor: "status",
        filterable: true,
        Cell: (cellProps: { row: { original: Offer } }) => {
          const { status, id } = cellProps.row.original
          return (
            <div className="form-check form-switch mb-3">
              {status === CurrentTapType.ended ? (
                <span className="badge text-success bg-success-30 me-1 px-2 py-1 font-size-10">
                  {t(status)}
                </span>
              ) : (
                <>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`customSwitch${id}`}
                    checked={status === CurrentTapType.active}
                    onClick={() => toggleActiveOffer(cellProps.row.original)}
                    onChange={() => {}}
                  />
                  <label
                    className="form-check-label text-capitalize"
                    htmlFor={`customSwitch${id}`}
                  >
                    {t(status)}
                  </label>
                </>
              )}
            </div>
          )
        },
      },
      {
        Header: " ",
        Cell: (cellProps: { row: { original: Offer } }) => {
          const offer = cellProps.row.original
          return (
            <UncontrolledDropdown>
              <DropdownToggle tag="a" className="card-drop">
                <i className="mdi mdi-dots-vertical font-size-18"></i>
              </DropdownToggle>

              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem onClick={() => editOfferHandler(offer)}>
                  <span className="">{t("common_edit")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => viewDetailsHandler(offer)}>
                  <span className="">{t("common_viewDetails")}</span>
                </DropdownItem>
                <DropdownItem onClick={() => deleteOfferHandler(offer)}>
                  <span className="text-danger">{t("offers_deleteOffer")}</span>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          )
        },
      },
    ],
    [offers, t, checkedOffers]
  )

  return (
    <TableContainer
      columns={columns}
      data={offers}
      isGlobalFilter={true}
      isAddOptions={false}
      customPageSize={5}
      isJobListGlobalFilter={undefined}
      isAddUserList={undefined}
      handleOrderClicks={undefined}
      handleUserClick={undefined}
      handleCustomerClick={undefined}
      isAddCustList={undefined}
      className={undefined}
      customPageSizeOptions={undefined}
    />
  )
}

OffersTable.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(OffersTable))
